import { useState } from "react";
import { useFriendRequestsContext } from "../contexts/FriendRequestsContext";
import friendshipService from "../services/friendshipService";

const useFriendRequests = () => {
  const { requests, loading, hasRequests } = useFriendRequestsContext();
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(new Set());

  const wrap = (fn) => async (id) => {
    if (busy.has(id)) return;
    setBusy((prev) => new Set(prev).add(id));
    setError(null);
    try {
      await fn(id);
      return true;
    } catch (e) {
      setError(e.message || "Action failed");
      return false;
    } finally {
      setBusy((prev) => {
        const n = new Set(prev);
        n.delete(id);
        return n;
      });
    }
  };

  return {
    requests,
    loading,
    error,
    isProcessingRequest: (id) => busy.has(id),
    acceptRequest: wrap(
      friendshipService.acceptFriendRequest.bind(friendshipService)
    ),
    declineRequest: wrap(
      friendshipService.declineFriendRequest.bind(friendshipService)
    ),
    hasRequests,
  };
};

export default useFriendRequests;
